import { useEffect, useState } from "react";
import ImageWithFallback from "./ui/ImageWithFallback";

const OrganonOrderingCartMyOrderConfirmation = () => {
    const [isContentLoaded, setIsContentLoaded] = useState(false);
    const [patientResources, setPatientResources] = useState([]);
    const [shippingAddress, setShippingAddress] = useState({
        orderNo: '',
        email: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        practiceName: '',
        address: '',
        appartment: '',
        suite: '',
        city: '',
        province: '',
        postcode: '',
        orderItems: []
    });

    /**
     * Effect to load order confirmation data from localStorage
     * and set the shipping address and patient resources.
     */
    useEffect(() => {
        const userProfileData = JSON.parse(localStorage.getItem("janrainCaptureProfileData"));
        const orderConfirmationData = JSON.parse(localStorage.getItem("orderconfirmationdatafromcheckout")) || {};
        setPatientResources(orderConfirmationData.orderItems || []);
        if (orderConfirmationData.orderNo) {
            setShippingAddress(prev => ({
                ...prev,
                ...orderConfirmationData // Load all stored order confirmation data
            }));
        } else if (userProfileData) {
            setShippingAddress(prev => ({
                ...prev,
                email: userProfileData.email,
                firstName: userProfileData.givenName || "",
                lastName: userProfileData.familyName || "",
                phoneNumber: userProfileData.address?.phone || "",
                address: userProfileData.address?.addressLine1 || "",
                appartment: userProfileData.address?.addressLine2 || "",
                city: userProfileData.address?.district || "",
                province: userProfileData.address?.state || "",
                postcode: userProfileData.address?.postalCode || "",
            }));
        }
        setIsContentLoaded(true);
    }, []);

    // Extract values from global ordering_cart_script_checkout object
    const {
        lang_thanks_order_msg,
        lang_confirmation_order_msg,
        lang_confirmation_order_number,
        thankyou_image,
        cart_information,
        customer_information,
        lang_contact_information,
        lang_si_shipping_information,
        lang_order_summary,
        template_directory_uri,
        lang_cart_empty_msg
    } = window.ordering_cart_script_checkout;

    return (
        <div className="orderConfirmationContainer">
            {!isContentLoaded ? (
                <div className="product-container container text-center">
                    <img src={`${template_directory_uri}/assets/images/spinner.gif`} alt="Loading spinner" />
                </div>
            ) : (
                <div className="container">
                    <div className="row">
                        <div className="orderconfirmationcontactshippingContainer">
                            {/* Accordion for Order Summary */}
                            <div className="accordion accordion-flush mobileorderconfirmation">
                                <button className="accordion-button collapsed" data-bs-toggle="collapse">
                                    <p className="ordersummaryttitle">{lang_order_summary}</p>
                                </button>
                                <div className="mobileorderconfirmationcontent">
                                    {patientResources.length > 0 ? (
                                        patientResources.map((item, index) => (
                                            <div key={index} className="checkoutCards">
                                                <div className="confirmationcardBody">
                                                    <ImageWithFallback fallback={`${template_directory_uri}/assets/images/no_preview.png`} src={item.material_image} alt={item.post_title} />
                                                    <div className="confirmationcardBodyContent">
                                                        <h2>{item.post_title}</h2>
                                                        <p>{item.order_variant} {item.order_size && `, ${item.order_size}`}</p>
                                                        <p className="confirmationItemQuantity">x{item.order_quantity}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>{lang_cart_empty_msg}</p>
                                    )}
                                </div>
                            </div>

                            {/* Order Confirmation Message */}
                            <p className="orderthankstitle">{lang_thanks_order_msg}</p>
                            <div className="orderinfoContainerOrderConfirm">
                                <p className="orderconfirmationttitle">{lang_confirmation_order_msg}</p>
                                <h5 className="confirmationnumber">{lang_confirmation_order_number} {shippingAddress.orderNo}</h5>
                                {thankyou_image &&  <ImageWithFallback src={thankyou_image} fallback={`${template_directory_uri}/assets/images/thank-you-email-graphic.png`} className={'img-fluid'} alt="Thank You" />}
                                <p className="cartInformation">{cart_information}</p>
                            </div>

                            {/* Customer Information */}
                            <div className="customerinfoContainerOrderConfirm">
                                <h4 className="customerinformationttitle">{customer_information}</h4>
                                <h3 className="contactinformation">{lang_contact_information}</h3>
                                <p className="orderinfopara">Order ID: {shippingAddress.orderNo}</p>
                                <p className="orderinfopara">{shippingAddress.email}</p>
                                <p className="orderinfopara">{shippingAddress.firstName} {shippingAddress.lastName}</p>
                                <p className="orderinfopara">{shippingAddress.phoneNumber}</p>

                                <h3 className="contactinformation">{lang_si_shipping_information}</h3>
                                <p className="orderinfopara">{shippingAddress.practiceName}</p>
                                <p className="orderinfopara">{shippingAddress.address}</p>
                                <p className="orderinfopara">{shippingAddress.appartment}</p>
                                <p className="orderinfopara">{shippingAddress.suite}</p>
                                <p className="orderinfopara">{shippingAddress.city}, {shippingAddress.province}</p>
                                <p className="orderinfopara">{shippingAddress.postcode}</p>
                            </div>
                        </div>

                        {/* Order Summary */}
                        <div className="orderSummaryConfirmationPage">
                            <p className="ordersummaryttitle">{lang_order_summary}</p>
                            {patientResources.length > 0 ? (
                                patientResources.map((item, index) => (
                                    <div key={index} className="checkoutCards">
                                        <div className="confirmationcardBody">
                                            <ImageWithFallback fallback={`${template_directory_uri}/assets/images/no_preview.png`} src={item.material_image} alt={item.post_title} />
                                            <div className="confirmationcardBodyContent">
                                                <h2>{item.post_title}</h2>
                                                <p>{item.order_variant} {item.order_size && `, ${item.order_size}`}</p>
                                                <p className="confirmationItemQuantity">x{item.order_quantity}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>{lang_cart_empty_msg}</p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrganonOrderingCartMyOrderConfirmation;